import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M4 20.0001V13H11L7.783 16.22C8.89296 17.355 10.4125 17.9964 12 18C14.5394 17.9963 16.8015 16.3942 17.648 14H17.666C17.7805 13.6746 17.8672 13.3401 17.925 13H19.937C19.4331 16.9999 16.0315 19.9999 12 20.0001H11.99C9.86876 20.0064 7.83316 19.1637 6.337 17.66L4 20.0001ZM6.074 11H4.062C4.56575 7.00163 7.965 4.00216 11.995 3.99998H12C14.1216 3.99319 16.1577 4.83586 17.654 6.34002L20 3.99998V11H13L16.222 7.78002C15.1109 6.64367 13.5893 6.00216 12 6.00002C9.46055 6.00377 7.19848 7.6058 6.352 10H6.334C6.21856 10.3251 6.13189 10.6597 6.075 11H6.074Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Refresh02"
);
